import type { CollapseProps } from "antd";

import BannerInfo from "./Info";
import BannerFiles from "./BannerFiles";
import BannerDetail from "./BannerDetail";

type BannerItemsProps = {
	hasNavigation?: boolean;
	onHasNavigationChange: (checked: boolean) => void;
};

export const BannerDetailConstants = {
	EN: "Banner Detayları - İngilizce",
	TR: "Banner Detayları"
};

export const BannerConstants = {
	INFO: "Banner Özellikleri",
	BANNER_FILES: "Banner Resimleri",
	BANNER_LOCALIZABLE: BannerDetailConstants,
};

export const getBannerItems = ({
	hasNavigation,
	onHasNavigationChange,
}: BannerItemsProps): CollapseProps["items"] => [
	{
		key: "1",
		label: BannerConstants.INFO,
		children: <BannerInfo hasNavigation={hasNavigation} onHasNavigationChange={onHasNavigationChange}  />,
	},
	{
		key: "2",
		label: BannerConstants.BANNER_FILES,
		children: <BannerFiles />,
	},
	{
		key: "3",
		label: BannerConstants.BANNER_LOCALIZABLE.TR,
		children: <BannerDetail Culture="tr-TR" hasNavigation={hasNavigation} />,
	},
	{
		key: "4",
		label: BannerConstants.BANNER_LOCALIZABLE.EN,
		children: <BannerDetail Culture="en-US" hasNavigation={hasNavigation} />,
	}
];
